export default __webpack_public_path__ + "static/media/news3.e9fc73d3.jpg";